import { useSelector } from 'react-redux'
import { selectors } from '../store'

export const useGetCountryProperties = () => {
  const countries = useSelector(selectors.settings.getCountries)

  const getCountryCode = (countryId?: string | number) => {
    if (!countryId) return
    return countries?.find(country => country.id === countryId)?.code
  }

  const getCountryName = (countryId?: string | number) => {
    if (!countryId) return
    return countries?.find(country => country.id === countryId)?.name
  }

  const getPhonePrefix = (countryId?: string | number) =>
    countries?.find(country => country.id === countryId)?.phonePrefix

  return { getCountryCode, getCountryName, getPhonePrefix }
}
